export default [
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/5CCwRZC6euC8Odo6y9X8jr'
          },
          href: 'https://api.spotify.com/v1/artists/5CCwRZC6euC8Odo6y9X8jr',
          id: '5CCwRZC6euC8Odo6y9X8jr',
          name: 'Rita Ora',
          type: 'artist',
          uri: 'spotify:artist:5CCwRZC6euC8Odo6y9X8jr'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/64M6ah0SkkRsnPGtGiRAbb'
          },
          href: 'https://api.spotify.com/v1/artists/64M6ah0SkkRsnPGtGiRAbb',
          id: '64M6ah0SkkRsnPGtGiRAbb',
          name: 'Bebe Rexha',
          type: 'artist',
          uri: 'spotify:artist:64M6ah0SkkRsnPGtGiRAbb'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/25uiPmTg16RbhZWAqwLBy5'
          },
          href: 'https://api.spotify.com/v1/artists/25uiPmTg16RbhZWAqwLBy5',
          id: '25uiPmTg16RbhZWAqwLBy5',
          name: 'Charli XCX',
          type: 'artist',
          uri: 'spotify:artist:25uiPmTg16RbhZWAqwLBy5'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/0TITR3yePyzJvlnQk61AWP'
      },
      href: 'https://api.spotify.com/v1/albums/0TITR3yePyzJvlnQk61AWP',
      id: '0TITR3yePyzJvlnQk61AWP',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/17422a849b425d4fbffaac45e689daceff519b3e',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/1cafb67a9b9498414c35c7f91713c64a7fc8b1a9',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/10d3d62b721998d60a794fdd3b146c21edbc9286',
          width: 64
        }
      ],
      name: 'Girls (feat. Cardi B, Bebe Rexha & Charli XCX)',
      type: 'album',
      uri: 'spotify:album:0TITR3yePyzJvlnQk61AWP'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5CCwRZC6euC8Odo6y9X8jr'
        },
        href: 'https://api.spotify.com/v1/artists/5CCwRZC6euC8Odo6y9X8jr',
        id: '5CCwRZC6euC8Odo6y9X8jr',
        name: 'Rita Ora',
        type: 'artist',
        uri: 'spotify:artist:5CCwRZC6euC8Odo6y9X8jr'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/64M6ah0SkkRsnPGtGiRAbb'
        },
        href: 'https://api.spotify.com/v1/artists/64M6ah0SkkRsnPGtGiRAbb',
        id: '64M6ah0SkkRsnPGtGiRAbb',
        name: 'Bebe Rexha',
        type: 'artist',
        uri: 'spotify:artist:64M6ah0SkkRsnPGtGiRAbb'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/25uiPmTg16RbhZWAqwLBy5'
        },
        href: 'https://api.spotify.com/v1/artists/25uiPmTg16RbhZWAqwLBy5',
        id: '25uiPmTg16RbhZWAqwLBy5',
        name: 'Charli XCX',
        type: 'artist',
        uri: 'spotify:artist:25uiPmTg16RbhZWAqwLBy5'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4kYSro6naA4h99UJvo89HB'
        },
        href: 'https://api.spotify.com/v1/artists/4kYSro6naA4h99UJvo89HB',
        id: '4kYSro6naA4h99UJvo89HB',
        name: 'Cardi B',
        type: 'artist',
        uri: 'spotify:artist:4kYSro6naA4h99UJvo89HB'
      }
    ],
    disc_number: 1,
    duration_ms: 221153,
    explicit: true,
    external_ids: {
      isrc: 'GBAHS1800321'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1YNQscOx6OqBQjxgJVhEeW'
    },
    href: 'https://api.spotify.com/v1/tracks/1YNQscOx6OqBQjxgJVhEeW',
    id: '1YNQscOx6OqBQjxgJVhEeW',
    is_playable: true,
    name: 'Girls (feat. Cardi B, Bebe Rexha & Charli XCX)',
    popularity: 80,
    preview_url:
      'https://p.scdn.co/mp3-preview/426443150e4972b4204153fdfe27b7380a81c0c4?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:1YNQscOx6OqBQjxgJVhEeW'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
          },
          href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
          id: '66CXWjxzNUsdJxJ2JdwvnR',
          name: 'Ariana Grande',
          type: 'artist',
          uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3OZgEywV4krCZ814pTJWr7'
      },
      href: 'https://api.spotify.com/v1/albums/3OZgEywV4krCZ814pTJWr7',
      id: '3OZgEywV4krCZ814pTJWr7',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/7625508bdbd4f4c2a92ef996ce07948b7e2adcf7',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/9e44039597fb2082cf8bc4541826cf4007fba25b',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/19028fe802123448daf860284dcd05e24c70b784',
          width: 64
        }
      ],
      name: 'Dangerous Woman',
      type: 'album',
      uri: 'spotify:album:3OZgEywV4krCZ814pTJWr7'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
        },
        href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
        id: '66CXWjxzNUsdJxJ2JdwvnR',
        name: 'Ariana Grande',
        type: 'artist',
        uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
      }
    ],
    disc_number: 1,
    duration_ms: 226426,
    explicit: true,
    external_ids: {
      isrc: 'USUM71602113'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1j0Rb762xxT0eccglHKsRv'
    },
    href: 'https://api.spotify.com/v1/tracks/1j0Rb762xxT0eccglHKsRv',
    id: '1j0Rb762xxT0eccglHKsRv',
    is_playable: true,
    name: 'Bad Decisions',
    popularity: 65,
    preview_url: null,
    track_number: 12,
    type: 'track',
    uri: 'spotify:track:1j0Rb762xxT0eccglHKsRv'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
          },
          href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
          id: '7n2wHs1TKAczGzO7Dd2rGr',
          name: 'Shawn Mendes',
          type: 'artist',
          uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6sUOosXuYt0oUeczJRbedZ'
      },
      href: 'https://api.spotify.com/v1/albums/6sUOosXuYt0oUeczJRbedZ',
      id: '6sUOosXuYt0oUeczJRbedZ',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/ddabe85ee59f580f6317418587b9816e96dcdff0',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/618aa045eac387aad90b736bb47594aa283a3e42',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/ff533dd65ffb84f9e9d632dc3b1750ddd1552dce',
          width: 64
        }
      ],
      name: 'Handwritten',
      type: 'album',
      uri: 'spotify:album:6sUOosXuYt0oUeczJRbedZ'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
        },
        href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
        id: '7n2wHs1TKAczGzO7Dd2rGr',
        name: 'Shawn Mendes',
        type: 'artist',
        uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
      }
    ],
    disc_number: 1,
    duration_ms: 206880,
    explicit: false,
    external_ids: {
      isrc: 'USUM71500658'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/5jsw9uXEGuKyJzs0boZ1bT'
    },
    href: 'https://api.spotify.com/v1/tracks/5jsw9uXEGuKyJzs0boZ1bT',
    id: '5jsw9uXEGuKyJzs0boZ1bT',
    is_playable: true,
    linked_from: {
      external_urls: {
        spotify: 'https://open.spotify.com/track/3zkWCteF82vJwv0hRLba76'
      },
      href: 'https://api.spotify.com/v1/tracks/3zkWCteF82vJwv0hRLba76',
      id: '3zkWCteF82vJwv0hRLba76',
      type: 'track',
      uri: 'spotify:track:3zkWCteF82vJwv0hRLba76'
    },
    name: 'Stitches',
    popularity: 70,
    preview_url: null,
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:5jsw9uXEGuKyJzs0boZ1bT'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh'
          },
          href: 'https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh',
          id: '0hCNtLu0JehylgoiP8L4Gh',
          name: 'Nicki Minaj',
          type: 'artist',
          uri: 'spotify:artist:0hCNtLu0JehylgoiP8L4Gh'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/2acDkDTWdNFie1HjcFa4Ny'
      },
      href: 'https://api.spotify.com/v1/albums/2acDkDTWdNFie1HjcFa4Ny',
      id: '2acDkDTWdNFie1HjcFa4Ny',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/39d4e59532356a393989fcbbe4335f47c6a62ce1',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/95453fa449e3edb2005fd3e714e90a2308c8d7f6',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/bfbedbc19b3d5fd52b079b5b1a78c2e5692692ae',
          width: 64
        }
      ],
      name: 'Queen',
      type: 'album',
      uri: 'spotify:album:2acDkDTWdNFie1HjcFa4Ny'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh'
        },
        href: 'https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh',
        id: '0hCNtLu0JehylgoiP8L4Gh',
        name: 'Nicki Minaj',
        type: 'artist',
        uri: 'spotify:artist:0hCNtLu0JehylgoiP8L4Gh'
      }
    ],
    disc_number: 1,
    duration_ms: 221853,
    explicit: true,
    external_ids: {
      isrc: 'USCM51800144'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7CKR3FcBqSsGcgce0ECe1z'
    },
    href: 'https://api.spotify.com/v1/tracks/7CKR3FcBqSsGcgce0ECe1z',
    id: '7CKR3FcBqSsGcgce0ECe1z',
    is_playable: true,
    name: 'LLC',
    popularity: 74,
    preview_url: null,
    track_number: 11,
    type: 'track',
    uri: 'spotify:track:7CKR3FcBqSsGcgce0ECe1z'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/5p7f24Rk5HkUZsaS3BLG5F'
          },
          href: 'https://api.spotify.com/v1/artists/5p7f24Rk5HkUZsaS3BLG5F',
          id: '5p7f24Rk5HkUZsaS3BLG5F',
          name: 'Hailee Steinfeld',
          type: 'artist',
          uri: 'spotify:artist:5p7f24Rk5HkUZsaS3BLG5F'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1ABRc0UFHY3x6rKQeFBTQ0'
      },
      href: 'https://api.spotify.com/v1/albums/1ABRc0UFHY3x6rKQeFBTQ0',
      id: '1ABRc0UFHY3x6rKQeFBTQ0',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/85102d1e9b1583ff06e6f109978ad087bc1e68bd',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/b45dcbcc5ca91fa310709fead869821bc0e6373d',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/506121028942a2c44bb912a29b9e4c224423d232',
          width: 64
        }
      ],
      name: 'HAIZ',
      type: 'album',
      uri: 'spotify:album:1ABRc0UFHY3x6rKQeFBTQ0'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5p7f24Rk5HkUZsaS3BLG5F'
        },
        href: 'https://api.spotify.com/v1/artists/5p7f24Rk5HkUZsaS3BLG5F',
        id: '5p7f24Rk5HkUZsaS3BLG5F',
        name: 'Hailee Steinfeld',
        type: 'artist',
        uri: 'spotify:artist:5p7f24Rk5HkUZsaS3BLG5F'
      }
    ],
    disc_number: 1,
    duration_ms: 216333,
    explicit: false,
    external_ids: {
      isrc: 'USUM71517731'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/3QTDzwSkRW04FVPo6COm0H'
    },
    href: 'https://api.spotify.com/v1/tracks/3QTDzwSkRW04FVPo6COm0H',
    id: '3QTDzwSkRW04FVPo6COm0H',
    is_playable: true,
    name: "You're Such A",
    popularity: 69,
    preview_url: null,
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:3QTDzwSkRW04FVPo6COm0H'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1l7ZsJRRS8wlW3WfJfPfNS'
          },
          href: 'https://api.spotify.com/v1/artists/1l7ZsJRRS8wlW3WfJfPfNS',
          id: '1l7ZsJRRS8wlW3WfJfPfNS',
          name: 'Christina Aguilera',
          type: 'artist',
          uri: 'spotify:artist:1l7ZsJRRS8wlW3WfJfPfNS'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/323CkC5IKF9IakoJFSE8Yy'
      },
      href: 'https://api.spotify.com/v1/albums/323CkC5IKF9IakoJFSE8Yy',
      id: '323CkC5IKF9IakoJFSE8Yy',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/e92c731369da19d5f118f60130cc39c1dadc9a98',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/7c8f2b130257f2dc718505fb5825d508d4dd2614',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/ef84b6623469a487156119a35faf8d25b692f849',
          width: 64
        }
      ],
      name: 'Fall In Line',
      type: 'album',
      uri: 'spotify:album:323CkC5IKF9IakoJFSE8Yy'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1l7ZsJRRS8wlW3WfJfPfNS'
        },
        href: 'https://api.spotify.com/v1/artists/1l7ZsJRRS8wlW3WfJfPfNS',
        id: '1l7ZsJRRS8wlW3WfJfPfNS',
        name: 'Christina Aguilera',
        type: 'artist',
        uri: 'spotify:artist:1l7ZsJRRS8wlW3WfJfPfNS'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6S2OmqARrzebs0tKUEyXyp'
        },
        href: 'https://api.spotify.com/v1/artists/6S2OmqARrzebs0tKUEyXyp',
        id: '6S2OmqARrzebs0tKUEyXyp',
        name: 'Demi Lovato',
        type: 'artist',
        uri: 'spotify:artist:6S2OmqARrzebs0tKUEyXyp'
      }
    ],
    disc_number: 1,
    duration_ms: 248544,
    explicit: false,
    external_ids: {
      isrc: 'USRC11801868'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/25qfFpoGhk9Njgu5nl36sS'
    },
    href: 'https://api.spotify.com/v1/tracks/25qfFpoGhk9Njgu5nl36sS',
    id: '25qfFpoGhk9Njgu5nl36sS',
    is_playable: true,
    name: 'Fall In Line',
    popularity: 70,
    preview_url:
      'https://p.scdn.co/mp3-preview/f656fc172aa37e6cb6284150ec74ec419da28819?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:25qfFpoGhk9Njgu5nl36sS'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0C8ZW7ezQVs4URX5aX7Kqx'
          },
          href: 'https://api.spotify.com/v1/artists/0C8ZW7ezQVs4URX5aX7Kqx',
          id: '0C8ZW7ezQVs4URX5aX7Kqx',
          name: 'Selena Gomez',
          type: 'artist',
          uri: 'spotify:artist:0C8ZW7ezQVs4URX5aX7Kqx'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3N7eWDCvfWv34xWNohdHjO'
      },
      href: 'https://api.spotify.com/v1/albums/3N7eWDCvfWv34xWNohdHjO',
      id: '3N7eWDCvfWv34xWNohdHjO',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/f1bed2a50aea28b91592c2f26a1c84311a96d152',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/d9034b57cad7baa90d2019feb344abcefa4acf7c',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/f61a815b23941a913b4b75ae4e98b33da02d51f5',
          width: 64
        }
      ],
      name: 'Back To You (From 13 Reasons Why – Season 2 Soundtrack)',
      type: 'album',
      uri: 'spotify:album:3N7eWDCvfWv34xWNohdHjO'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0C8ZW7ezQVs4URX5aX7Kqx'
        },
        href: 'https://api.spotify.com/v1/artists/0C8ZW7ezQVs4URX5aX7Kqx',
        id: '0C8ZW7ezQVs4URX5aX7Kqx',
        name: 'Selena Gomez',
        type: 'artist',
        uri: 'spotify:artist:0C8ZW7ezQVs4URX5aX7Kqx'
      }
    ],
    disc_number: 1,
    duration_ms: 207904,
    explicit: false,
    external_ids: {
      isrc: 'USUM71805992'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4hQ6UGyWQIGJmHSo0J88JW'
    },
    href: 'https://api.spotify.com/v1/tracks/4hQ6UGyWQIGJmHSo0J88JW',
    id: '4hQ6UGyWQIGJmHSo0J88JW',
    is_playable: true,
    name: 'Back To You - From 13 Reasons Why – Season 2 Soundtrack',
    popularity: 88,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:4hQ6UGyWQIGJmHSo0J88JW'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
          },
          href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
          id: '66CXWjxzNUsdJxJ2JdwvnR',
          name: 'Ariana Grande',
          type: 'artist',
          uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3tx8gQqWbGwqIGZHqDNrGe'
      },
      href: 'https://api.spotify.com/v1/albums/3tx8gQqWbGwqIGZHqDNrGe',
      id: '3tx8gQqWbGwqIGZHqDNrGe',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/381891c42f301e0abaa1b1dcfbf0390334e698eb',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/64414f252b388c08d7c4f3c3d3fdddaf0b003382',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/994ee67e9011c743ec12a7ed410702a5791be68f',
          width: 64
        }
      ],
      name: 'Sweetener',
      type: 'album',
      uri: 'spotify:album:3tx8gQqWbGwqIGZHqDNrGe'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
        },
        href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
        id: '66CXWjxzNUsdJxJ2JdwvnR',
        name: 'Ariana Grande',
        type: 'artist',
        uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
      }
    ],
    disc_number: 1,
    duration_ms: 208493,
    explicit: true,
    external_ids: {
      isrc: 'USUM71808576'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/70khXICDeTTxgYtw3EysKH'
    },
    href: 'https://api.spotify.com/v1/tracks/70khXICDeTTxgYtw3EysKH',
    id: '70khXICDeTTxgYtw3EysKH',
    is_playable: true,
    name: 'sweetener',
    popularity: 85,
    preview_url: null,
    track_number: 6,
    type: 'track',
    uri: 'spotify:track:70khXICDeTTxgYtw3EysKH'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4AK6F7OLvEQ5QYCBNiQWHq'
          },
          href: 'https://api.spotify.com/v1/artists/4AK6F7OLvEQ5QYCBNiQWHq',
          id: '4AK6F7OLvEQ5QYCBNiQWHq',
          name: 'One Direction',
          type: 'artist',
          uri: 'spotify:artist:4AK6F7OLvEQ5QYCBNiQWHq'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7p1fX8aUySrBdx4WSYspOu'
      },
      href: 'https://api.spotify.com/v1/albums/7p1fX8aUySrBdx4WSYspOu',
      id: '7p1fX8aUySrBdx4WSYspOu',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/fa3dd6a5fab74f40b020da009825209c807213d3',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/02618ee3e7565e9012c5fedb35c1b36eedbbcd3d',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/e7cc8fe75b8beee36d0f3235a61faf074e6fe0ce',
          width: 64
        }
      ],
      name: 'Midnight Memories (Deluxe)',
      type: 'album',
      uri: 'spotify:album:7p1fX8aUySrBdx4WSYspOu'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4AK6F7OLvEQ5QYCBNiQWHq'
        },
        href: 'https://api.spotify.com/v1/artists/4AK6F7OLvEQ5QYCBNiQWHq',
        id: '4AK6F7OLvEQ5QYCBNiQWHq',
        name: 'One Direction',
        type: 'artist',
        uri: 'spotify:artist:4AK6F7OLvEQ5QYCBNiQWHq'
      }
    ],
    disc_number: 1,
    duration_ms: 245493,
    explicit: false,
    external_ids: {
      isrc: 'GBHMU1300210'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4nVBt6MZDDP6tRVdQTgxJg'
    },
    href: 'https://api.spotify.com/v1/tracks/4nVBt6MZDDP6tRVdQTgxJg',
    id: '4nVBt6MZDDP6tRVdQTgxJg',
    is_playable: true,
    name: 'Story of My Life',
    popularity: 75,
    preview_url:
      'https://p.scdn.co/mp3-preview/e8cbef539a2a32def5e66968cc00769a4f523c1c?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:4nVBt6MZDDP6tRVdQTgxJg'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1Hsdzj7Dlq2I7tHP7501T4'
          },
          href: 'https://api.spotify.com/v1/artists/1Hsdzj7Dlq2I7tHP7501T4',
          id: '1Hsdzj7Dlq2I7tHP7501T4',
          name: 'Niall Horan',
          type: 'artist',
          uri: 'spotify:artist:1Hsdzj7Dlq2I7tHP7501T4'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7ahctQBwcSxDdP0fRAPo2p'
      },
      href: 'https://api.spotify.com/v1/albums/7ahctQBwcSxDdP0fRAPo2p',
      id: '7ahctQBwcSxDdP0fRAPo2p',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/f13f1e0066ccad82ef66aad8299baf685abcdca6',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/640baafb85e0cff376e1a08d7021ce0cfd95d4d9',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/3774cb72ed5552c73c54a0b847897164821c1a13',
          width: 64
        }
      ],
      name: 'Flicker (Deluxe)',
      type: 'album',
      uri: 'spotify:album:7ahctQBwcSxDdP0fRAPo2p'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1Hsdzj7Dlq2I7tHP7501T4'
        },
        href: 'https://api.spotify.com/v1/artists/1Hsdzj7Dlq2I7tHP7501T4',
        id: '1Hsdzj7Dlq2I7tHP7501T4',
        name: 'Niall Horan',
        type: 'artist',
        uri: 'spotify:artist:1Hsdzj7Dlq2I7tHP7501T4'
      }
    ],
    disc_number: 1,
    duration_ms: 232852,
    explicit: false,
    external_ids: {
      isrc: 'USUG11601029'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/0qvzXomUDJVaUboy2wMfiS'
    },
    href: 'https://api.spotify.com/v1/tracks/0qvzXomUDJVaUboy2wMfiS',
    id: '0qvzXomUDJVaUboy2wMfiS',
    is_playable: true,
    name: 'This Town',
    popularity: 73,
    preview_url: null,
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:0qvzXomUDJVaUboy2wMfiS'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
          },
          href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
          id: '7n2wHs1TKAczGzO7Dd2rGr',
          name: 'Shawn Mendes',
          type: 'artist',
          uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/2VP96XdMOKTXefI8Nui23s'
      },
      href: 'https://api.spotify.com/v1/albums/2VP96XdMOKTXefI8Nui23s',
      id: '2VP96XdMOKTXefI8Nui23s',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/75c02b42da899fc03b8a3cbfb8686a3920385525',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/78eea1f0b06dcb4be755df52cba4498add46be10',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/2d0511fca7dd3030b8b52c1c77224c5ee7d33580',
          width: 64
        }
      ],
      name: 'Shawn Mendes',
      type: 'album',
      uri: 'spotify:album:2VP96XdMOKTXefI8Nui23s'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
        },
        href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
        id: '7n2wHs1TKAczGzO7Dd2rGr',
        name: 'Shawn Mendes',
        type: 'artist',
        uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6LuN9FCkKOj5PcnpouEgny'
        },
        href: 'https://api.spotify.com/v1/artists/6LuN9FCkKOj5PcnpouEgny',
        id: '6LuN9FCkKOj5PcnpouEgny',
        name: 'Khalid',
        type: 'artist',
        uri: 'spotify:artist:6LuN9FCkKOj5PcnpouEgny'
      }
    ],
    disc_number: 1,
    duration_ms: 190866,
    explicit: false,
    external_ids: {
      isrc: 'USUM71804955'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1h0yImRPIVAjhhHeNVlTuC'
    },
    href: 'https://api.spotify.com/v1/tracks/1h0yImRPIVAjhhHeNVlTuC',
    id: '1h0yImRPIVAjhhHeNVlTuC',
    is_playable: true,
    linked_from: {
      external_urls: {
        spotify: 'https://open.spotify.com/track/5SwEgzUFDHwpWHKrbnP32Z'
      },
      href: 'https://api.spotify.com/v1/tracks/5SwEgzUFDHwpWHKrbnP32Z',
      id: '5SwEgzUFDHwpWHKrbnP32Z',
      type: 'track',
      uri: 'spotify:track:5SwEgzUFDHwpWHKrbnP32Z'
    },
    name: 'Youth (feat. Khalid)',
    popularity: 75,
    preview_url: null,
    track_number: 10,
    type: 'track',
    uri: 'spotify:track:1h0yImRPIVAjhhHeNVlTuC'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/2kRfqPViCqYdSGhYSM9R0Q'
          },
          href: 'https://api.spotify.com/v1/artists/2kRfqPViCqYdSGhYSM9R0Q',
          id: '2kRfqPViCqYdSGhYSM9R0Q',
          name: 'Madison Beer',
          type: 'artist',
          uri: 'spotify:artist:2kRfqPViCqYdSGhYSM9R0Q'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/5boeEaUtj7gHXFxKtFFlzL'
      },
      href: 'https://api.spotify.com/v1/albums/5boeEaUtj7gHXFxKtFFlzL',
      id: '5boeEaUtj7gHXFxKtFFlzL',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/2793325ab7aab277ccf944b10a8318e75707897c',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/1d8fe22f7eaaf4cd13cb5a26e7bc1b758110c6ec',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/6b395b988db6f7b9c11a27ae6d28e1fcb8f6169a',
          width: 64
        }
      ],
      name: 'As She Pleases',
      type: 'album',
      uri: 'spotify:album:5boeEaUtj7gHXFxKtFFlzL'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/2kRfqPViCqYdSGhYSM9R0Q'
        },
        href: 'https://api.spotify.com/v1/artists/2kRfqPViCqYdSGhYSM9R0Q',
        id: '2kRfqPViCqYdSGhYSM9R0Q',
        name: 'Madison Beer',
        type: 'artist',
        uri: 'spotify:artist:2kRfqPViCqYdSGhYSM9R0Q'
      }
    ],
    disc_number: 1,
    duration_ms: 190576,
    explicit: false,
    external_ids: {
      isrc: 'GBKPL1897318'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/0iwsQWgtjSq2kUXuZwTDAL'
    },
    href: 'https://api.spotify.com/v1/tracks/0iwsQWgtjSq2kUXuZwTDAL',
    id: '0iwsQWgtjSq2kUXuZwTDAL',
    is_playable: true,
    name: 'Home with You',
    popularity: 79,
    preview_url:
      'https://p.scdn.co/mp3-preview/3dd4e833f706e3637eb3a6d46312c41c450a44f1?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 5,
    type: 'track',
    uri: 'spotify:track:0iwsQWgtjSq2kUXuZwTDAL'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/26VFTg2z8YR0cCuwLzESi2'
          },
          href: 'https://api.spotify.com/v1/artists/26VFTg2z8YR0cCuwLzESi2',
          id: '26VFTg2z8YR0cCuwLzESi2',
          name: 'Halsey',
          type: 'artist',
          uri: 'spotify:artist:26VFTg2z8YR0cCuwLzESi2'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7GjG91tyHQNGEHzKJaqOi0'
      },
      href: 'https://api.spotify.com/v1/albums/7GjG91tyHQNGEHzKJaqOi0',
      id: '7GjG91tyHQNGEHzKJaqOi0',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/c8af4aa7e5b7a022d9cb49471eb0b9e367ca23a8',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/9373fab2538eefd183cdd8ae086726b7ddeee001',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/f5fc62b1bad0786614c6c3b257acc9d53022773d',
          width: 64
        }
      ],
      name: 'hopeless fountain kingdom (Deluxe)',
      type: 'album',
      uri: 'spotify:album:7GjG91tyHQNGEHzKJaqOi0'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/26VFTg2z8YR0cCuwLzESi2'
        },
        href: 'https://api.spotify.com/v1/artists/26VFTg2z8YR0cCuwLzESi2',
        id: '26VFTg2z8YR0cCuwLzESi2',
        name: 'Halsey',
        type: 'artist',
        uri: 'spotify:artist:26VFTg2z8YR0cCuwLzESi2'
      }
    ],
    disc_number: 1,
    duration_ms: 214801,
    explicit: false,
    external_ids: {
      isrc: 'USUM71701077'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7i2DJ88J7jQ8K7zqFX2fW8'
    },
    href: 'https://api.spotify.com/v1/tracks/7i2DJ88J7jQ8K7zqFX2fW8',
    id: '7i2DJ88J7jQ8K7zqFX2fW8',
    is_playable: true,
    name: 'Now Or Never',
    popularity: 74,
    preview_url: null,
    track_number: 6,
    type: 'track',
    uri: 'spotify:track:7i2DJ88J7jQ8K7zqFX2fW8'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
          },
          href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
          id: '66CXWjxzNUsdJxJ2JdwvnR',
          name: 'Ariana Grande',
          type: 'artist',
          uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3OZgEywV4krCZ814pTJWr7'
      },
      href: 'https://api.spotify.com/v1/albums/3OZgEywV4krCZ814pTJWr7',
      id: '3OZgEywV4krCZ814pTJWr7',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/7625508bdbd4f4c2a92ef996ce07948b7e2adcf7',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/9e44039597fb2082cf8bc4541826cf4007fba25b',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/19028fe802123448daf860284dcd05e24c70b784',
          width: 64
        }
      ],
      name: 'Dangerous Woman',
      type: 'album',
      uri: 'spotify:album:3OZgEywV4krCZ814pTJWr7'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
        },
        href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
        id: '66CXWjxzNUsdJxJ2JdwvnR',
        name: 'Ariana Grande',
        type: 'artist',
        uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
      }
    ],
    disc_number: 1,
    duration_ms: 260000,
    explicit: false,
    external_ids: {
      isrc: 'USUM71602114'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7MGRcJy1saXKiphwqJBnRb'
    },
    href: 'https://api.spotify.com/v1/tracks/7MGRcJy1saXKiphwqJBnRb',
    id: '7MGRcJy1saXKiphwqJBnRb',
    is_playable: true,
    name: 'Touch It',
    popularity: 66,
    preview_url: null,
    track_number: 13,
    type: 'track',
    uri: 'spotify:track:7MGRcJy1saXKiphwqJBnRb'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/6S2OmqARrzebs0tKUEyXyp'
          },
          href: 'https://api.spotify.com/v1/artists/6S2OmqARrzebs0tKUEyXyp',
          id: '6S2OmqARrzebs0tKUEyXyp',
          name: 'Demi Lovato',
          type: 'artist',
          uri: 'spotify:artist:6S2OmqARrzebs0tKUEyXyp'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/233yswCIc7oCFpZ2M9t0wa'
      },
      href: 'https://api.spotify.com/v1/albums/233yswCIc7oCFpZ2M9t0wa',
      id: '233yswCIc7oCFpZ2M9t0wa',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/935655684497ababf12b8e90be788ddfd9266354',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/2420c8789b42a990e8dba16c1b77e29c838460d6',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/08a57cb98fc4cf781c064124630f99524e62a312',
          width: 64
        }
      ],
      name: 'Tell Me You Love Me',
      type: 'album',
      uri: 'spotify:album:233yswCIc7oCFpZ2M9t0wa'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6S2OmqARrzebs0tKUEyXyp'
        },
        href: 'https://api.spotify.com/v1/artists/6S2OmqARrzebs0tKUEyXyp',
        id: '6S2OmqARrzebs0tKUEyXyp',
        name: 'Demi Lovato',
        type: 'artist',
        uri: 'spotify:artist:6S2OmqARrzebs0tKUEyXyp'
      }
    ],
    disc_number: 1,
    duration_ms: 236986,
    explicit: false,
    external_ids: {
      isrc: 'USUM71709091'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/3hYvGiw2Q8QE2YWdIJLBz0'
    },
    href: 'https://api.spotify.com/v1/tracks/3hYvGiw2Q8QE2YWdIJLBz0',
    id: '3hYvGiw2Q8QE2YWdIJLBz0',
    is_playable: true,
    name: 'Tell Me You Love Me',
    popularity: 77,
    preview_url: null,
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:3hYvGiw2Q8QE2YWdIJLBz0'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0LyfQWJT6nXafLPZqxe9Of'
          },
          href: 'https://api.spotify.com/v1/artists/0LyfQWJT6nXafLPZqxe9Of',
          id: '0LyfQWJT6nXafLPZqxe9Of',
          name: 'Various Artists',
          type: 'artist',
          uri: 'spotify:artist:0LyfQWJT6nXafLPZqxe9Of'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/2ZeHAc9olOJ70wqPjHXhZE'
      },
      href: 'https://api.spotify.com/v1/albums/2ZeHAc9olOJ70wqPjHXhZE',
      id: '2ZeHAc9olOJ70wqPjHXhZE',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/4d2844ebdcd0d3b234643da591708f3117293de5',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/adf13738331a2cb336f4c27429f5e0046ef7743a',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/840bbea336020eab6a0682f7fb18793736882533',
          width: 64
        }
      ],
      name: 'Pitch Perfect 2 - Special Edition (Original Motion Picture Soundtrack)',
      type: 'album',
      uri: 'spotify:album:2ZeHAc9olOJ70wqPjHXhZE'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5p7f24Rk5HkUZsaS3BLG5F'
        },
        href: 'https://api.spotify.com/v1/artists/5p7f24Rk5HkUZsaS3BLG5F',
        id: '5p7f24Rk5HkUZsaS3BLG5F',
        name: 'Hailee Steinfeld',
        type: 'artist',
        uri: 'spotify:artist:5p7f24Rk5HkUZsaS3BLG5F'
      }
    ],
    disc_number: 1,
    duration_ms: 178320,
    explicit: false,
    external_ids: {
      isrc: 'USUM71510764'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/6W5RmgWh46p9RQ4LDezHKE'
    },
    href: 'https://api.spotify.com/v1/tracks/6W5RmgWh46p9RQ4LDezHKE',
    id: '6W5RmgWh46p9RQ4LDezHKE',
    is_playable: true,
    name: 'Flashlight (Sweet Life Mix) - From "Pitch Perfect 2" Soundtrack',
    popularity: 72,
    preview_url: null,
    track_number: 24,
    type: 'track',
    uri: 'spotify:track:6W5RmgWh46p9RQ4LDezHKE'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh'
          },
          href: 'https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh',
          id: '0hCNtLu0JehylgoiP8L4Gh',
          name: 'Nicki Minaj',
          type: 'artist',
          uri: 'spotify:artist:0hCNtLu0JehylgoiP8L4Gh'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/2acDkDTWdNFie1HjcFa4Ny'
      },
      href: 'https://api.spotify.com/v1/albums/2acDkDTWdNFie1HjcFa4Ny',
      id: '2acDkDTWdNFie1HjcFa4Ny',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/39d4e59532356a393989fcbbe4335f47c6a62ce1',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/95453fa449e3edb2005fd3e714e90a2308c8d7f6',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/bfbedbc19b3d5fd52b079b5b1a78c2e5692692ae',
          width: 64
        }
      ],
      name: 'Queen',
      type: 'album',
      uri: 'spotify:album:2acDkDTWdNFie1HjcFa4Ny'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh'
        },
        href: 'https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh',
        id: '0hCNtLu0JehylgoiP8L4Gh',
        name: 'Nicki Minaj',
        type: 'artist',
        uri: 'spotify:artist:0hCNtLu0JehylgoiP8L4Gh'
      }
    ],
    disc_number: 1,
    duration_ms: 246240,
    explicit: true,
    external_ids: {
      isrc: 'USCM51800148'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2PiPXo7l8Vozdt9QZk1Lvw'
    },
    href: 'https://api.spotify.com/v1/tracks/2PiPXo7l8Vozdt9QZk1Lvw',
    id: '2PiPXo7l8Vozdt9QZk1Lvw',
    is_playable: true,
    name: 'Come See About Me',
    popularity: 69,
    preview_url: null,
    track_number: 15,
    type: 'track',
    uri: 'spotify:track:2PiPXo7l8Vozdt9QZk1Lvw'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
          },
          href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
          id: '66CXWjxzNUsdJxJ2JdwvnR',
          name: 'Ariana Grande',
          type: 'artist',
          uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3IGM1sXYke2UGII2DORrof'
      },
      href: 'https://api.spotify.com/v1/albums/3IGM1sXYke2UGII2DORrof',
      id: '3IGM1sXYke2UGII2DORrof',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/55b219724f602a55cc3c7f97418ff77846ed5bb2',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/dc1d6cb9ba9c1a6ba20b15b810c874d00349df73',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/2dbfd4953a8455c98ebfe1a65789307c0826a090',
          width: 64
        }
      ],
      name: 'Focus',
      type: 'album',
      uri: 'spotify:album:3IGM1sXYke2UGII2DORrof'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR'
        },
        href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
        id: '66CXWjxzNUsdJxJ2JdwvnR',
        name: 'Ariana Grande',
        type: 'artist',
        uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR'
      }
    ],
    disc_number: 1,
    duration_ms: 211360,
    explicit: false,
    external_ids: {
      isrc: 'USUM71516960'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1cdzfFjEbUbgTm5nv3FgXR'
    },
    href: 'https://api.spotify.com/v1/tracks/1cdzfFjEbUbgTm5nv3FgXR',
    id: '1cdzfFjEbUbgTm5nv3FgXR',
    is_playable: true,
    name: 'Focus',
    popularity: 65,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:1cdzfFjEbUbgTm5nv3FgXR'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
          },
          href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
          id: '7n2wHs1TKAczGzO7Dd2rGr',
          name: 'Shawn Mendes',
          type: 'artist',
          uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/2VP96XdMOKTXefI8Nui23s'
      },
      href: 'https://api.spotify.com/v1/albums/2VP96XdMOKTXefI8Nui23s',
      id: '2VP96XdMOKTXefI8Nui23s',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/75c02b42da899fc03b8a3cbfb8686a3920385525',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/78eea1f0b06dcb4be755df52cba4498add46be10',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/2d0511fca7dd3030b8b52c1c77224c5ee7d33580',
          width: 64
        }
      ],
      name: 'Shawn Mendes',
      type: 'album',
      uri: 'spotify:album:2VP96XdMOKTXefI8Nui23s'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/7n2wHs1TKAczGzO7Dd2rGr'
        },
        href: 'https://api.spotify.com/v1/artists/7n2wHs1TKAczGzO7Dd2rGr',
        id: '7n2wHs1TKAczGzO7Dd2rGr',
        name: 'Shawn Mendes',
        type: 'artist',
        uri: 'spotify:artist:7n2wHs1TKAczGzO7Dd2rGr'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0ZED1XzwlLHW4ZaG4lOT6m'
        },
        href: 'https://api.spotify.com/v1/artists/0ZED1XzwlLHW4ZaG4lOT6m',
        id: '0ZED1XzwlLHW4ZaG4lOT6m',
        name: 'Julia Michaels',
        type: 'artist',
        uri: 'spotify:artist:0ZED1XzwlLHW4ZaG4lOT6m'
      }
    ],
    disc_number: 1,
    duration_ms: 159400,
    explicit: false,
    external_ids: {
      isrc: 'USUM71804959'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2IssBpPtHcViZL5vYQNHhA'
    },
    href: 'https://api.spotify.com/v1/tracks/2IssBpPtHcViZL5vYQNHhA',
    id: '2IssBpPtHcViZL5vYQNHhA',
    is_playable: true,
    linked_from: {
      external_urls: {
        spotify: 'https://open.spotify.com/track/5QskYLFPX9y7pLU0VEMNbr'
      },
      href: 'https://api.spotify.com/v1/tracks/5QskYLFPX9y7pLU0VEMNbr',
      id: '5QskYLFPX9y7pLU0VEMNbr',
      type: 'track',
      uri: 'spotify:track:5QskYLFPX9y7pLU0VEMNbr'
    },
    name: 'Like To Be You (feat. Julia Michaels)',
    popularity: 71,
    preview_url: null,
    track_number: 5,
    type: 'track',
    uri: 'spotify:track:2IssBpPtHcViZL5vYQNHhA'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1Hsdzj7Dlq2I7tHP7501T4'
          },
          href: 'https://api.spotify.com/v1/artists/1Hsdzj7Dlq2I7tHP7501T4',
          id: '1Hsdzj7Dlq2I7tHP7501T4',
          name: 'Niall Horan',
          type: 'artist',
          uri: 'spotify:artist:1Hsdzj7Dlq2I7tHP7501T4'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7ahctQBwcSxDdP0fRAPo2p'
      },
      href: 'https://api.spotify.com/v1/albums/7ahctQBwcSxDdP0fRAPo2p',
      id: '7ahctQBwcSxDdP0fRAPo2p',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/f13f1e0066ccad82ef66aad8299baf685abcdca6',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/640baafb85e0cff376e1a08d7021ce0cfd95d4d9',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/3774cb72ed5552c73c54a0b847897164821c1a13',
          width: 64
        }
      ],
      name: 'Flicker (Deluxe)',
      type: 'album',
      uri: 'spotify:album:7ahctQBwcSxDdP0fRAPo2p'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1Hsdzj7Dlq2I7tHP7501T4'
        },
        href: 'https://api.spotify.com/v1/artists/1Hsdzj7Dlq2I7tHP7501T4',
        id: '1Hsdzj7Dlq2I7tHP7501T4',
        name: 'Niall Horan',
        type: 'artist',
        uri: 'spotify:artist:1Hsdzj7Dlq2I7tHP7501T4'
      }
    ],
    disc_number: 1,
    duration_ms: 188174,
    explicit: false,
    external_ids: {
      isrc: 'USUG11700631'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2cOUlop2ZakjOKe4WinesN'
    },
    href: 'https://api.spotify.com/v1/tracks/2cOUlop2ZakjOKe4WinesN',
    id: '2cOUlop2ZakjOKe4WinesN',
    is_playable: true,
    name: 'Slow Hands',
    popularity: 77,
    preview_url: null,
    track_number: 4,
    type: 'track',
    uri: 'spotify:track:2cOUlop2ZakjOKe4WinesN'
  }
];



// WEBPACK FOOTER //
// ./src/utils/data/ariana.js